<nav class="navbar">
  <a href="{{ environment.url }}/#/infokios">Infokiosk</a>
  <a href="{{ environment.url }}/#/display">Ekran</a>
  <a href="{{ environment.url }}/#/queue-officer">Dispetcher</a>
  <a href="{{ environment.url }}/#/queue">Admin</a>
</nav>
